module.exports = __webpack_public_path__ + "static/media/Survivor@768.4253daa1.png";